import React,{useState} from 'react';
import CareerModal from '../CareerModal/CareerModal';

const CareerCard = ({slider}) => {
    const [showModal,setModal]=useState(false)

    return (
        <div className="row   " key={Date.now() + Math.random()}>
            <div className="col-11 g-2">
                <div
                    onClick={() =>!showModal && setModal(!showModal)}
                    className='career-card  pb-0 '>

                    <p style={{ fontWeight: 700 }} className='primary-text'>{slider?.node.designation[0]?.text}</p>
                    <div className="d-flex ">
                        <div className=" d-flex  flex-column flex-grow-1   pe-2">

                            <div className="d-flex  flex-md-column   flex-sm-row justify-content-between ">
                                <p className='primary-text '>{slider?.node.location[0]?.text}</p>
                                <p className='primary-text '>{slider?.node.job_type[0]?.text}</p>
                            </div>
                        </div>

                        <div className="d-flex ">

                            <div className=" align-self-end carrer-sld-btn  pb-0">
                                <CareerModal modalInfo={slider?.node} showModal={showModal} setModal={setModal}/>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CareerCard;